import { RightSidebarOpeneableApps } from './rightSidebarConfiguration';

export const BASIC_PANEL_WIDTH = 310;
export const EXTENDED_PANEL_WIDTH = 310;

export const rightSidebarSizePerOpenedApp: {[key in keyof typeof RightSidebarOpeneableApps]: number} = {
  [RightSidebarOpeneableApps.EditPanel]: EXTENDED_PANEL_WIDTH,
};
